<template>
  <div class="w-full flex flex-col lg:flex-row gap-12 md:gap-20 lg:px-12 items-center lg:items-start">
    <h2 class="font-title text-2xl leading-6 md:text-4xl md:leading-10 text-ocean-950 font-bold">
      {{ $t('for-vets.faq-list.faq') }}
    </h2>
    <vetster-faq-content :questions="questions">
      <template #answer-0>
        <div class="flex flex-col gap-6">
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-1.answer') }}
          </p>
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-1.cta') }}
          </p>
          <vetster-blog-guide-card
            :date="$t('for-vets.faq-list.faq-1.guides.guide-1.date')"
            :reading-time="5"
            :title="$t('for-vets.faq-list.faq-1.guides.guide-1.title')"
            image-url="/images/for-vets/blog-guides/virtual-care.jpeg"
            link="/en/blog/for-vets/virtual-care-telehealth-telemedicine-teletriage-and-general-advice"
          />
        </div>
      </template>
      <template #answer-1>
        <div class="flex flex-col gap-6">
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-2.answer') }}
          </p>
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-2.cta') }}
          </p>
          <div class="flex gap-6 flex-col xl:flex-row">
            <vetster-blog-guide-card
              :date="$t('for-vets.faq-list.faq-2.guides.guide-1.date')"
              :reading-time="4"
              :title="$t('for-vets.faq-list.faq-2.guides.guide-1.title')"
              image-url="/images/for-vets/blog-guides/providing-a-great-virtual-experience.jpeg"
              link="/en/blog/for-vets/providing-a-great-virtual-care-experience"
            />
            <vetster-blog-guide-card
              :date="$t('for-vets.faq-list.faq-2.guides.guide-2.date')"
              :reading-time="7"
              :title="$t('for-vets.faq-list.faq-2.guides.guide-2.title')"
              image-url="/images/for-vets/blog-guides/mastering-the-virtual-exam.jpeg"
              link="/en/blog/for-vets/mastering-the-virtual-physical-exam"
            />
          </div>
        </div>
      </template>
      <template #answer-2>
        <div class="flex flex-col gap-6">
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-3.answer') }}
          </p>
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-3.cta') }}
          </p>
          <vetster-blog-guide-card
            :date="$t('for-vets.faq-list.faq-3.guides.guide-1.date')"
            :reading-time="3"
            :title="$t('for-vets.faq-list.faq-3.guides.guide-1.title')"
            image-url="/images/for-vets/blog-guides/what-is-marketplace.jpeg"
            link="/en/blog/for-vets/what-is-a-marketplace"
          />
        </div>
      </template>
      <template #answer-3>
        <div class="flex flex-col gap-6">
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-4.answer') }}
          </p>
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-4.cta') }}
          </p>
          <vetster-blog-guide-card
            :date="$t('for-vets.faq-list.faq-4.guides.guide-1.date')"
            :reading-time="6"
            :title="$t('for-vets.faq-list.faq-4.guides.guide-1.title')"
            image-url="/images/for-vets/blog-guides/why-choose-vetster.jpeg"
            link="/en/blog/for-vets/why-choose-vetster-over-zoom-or-facetime"
          />
        </div>
      </template>
      <template #answer-4>
        <div class="flex flex-col gap-6">
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-5.answer') }}
          </p>
          <p class="text-base leading-5 text-neutral-700">
            {{ $t('for-vets.faq-list.faq-5.cta') }}
          </p>
          <vetster-blog-guide-card
            :date="$t('for-vets.faq-list.faq-5.guides.guide-1.date')"
            :reading-time="7"
            :title="$t('for-vets.faq-list.faq-5.guides.guide-1.title')"
            image-url="/images/for-vets/blog-guides/using-vetster-for-your-clinic.jpeg"
            link="/en/blog/for-vets/using-vetster-for-your-clinic"
          />
        </div>
      </template>
      <template #answer-5>
        <p class="text-base leading-5 text-neutral-700">
          {{ $t('for-vets.faq-list.faq-6.answer') }}
        </p>
      </template>
    </vetster-faq-content>
  </div>
</template>

<script>
import VetsterBlogGuideCard from '@/components/VetsterBlogGuideCard';
import VetsterFaqContent from '@/components/VetsterFaqContent';

export default {
  name: 'VetsterForVetsFaq',

  components: {
    VetsterBlogGuideCard,
    VetsterFaqContent,
  },

  data() {
    return {
      questions: [
        this.$t('for-vets.faq-list.faq-1.question'),
        this.$t('for-vets.faq-list.faq-2.question'),
        this.$t('for-vets.faq-list.faq-3.question'),
        this.$t('for-vets.faq-list.faq-4.question'),
        this.$t('for-vets.faq-list.faq-5.question'),
        this.$t('for-vets.faq-list.faq-6.question'),
      ],
    };
  },
};
</script>
